import {Component, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {LoginAndRegDialogComponent} from '../../../../feature/login/components/login-and-reg-dialog/login-and-reg-dialog.component';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.scss']
})
export class UnauthorizedComponent implements OnInit {

  constructor(private readonly matDialog: MatDialog) { }

  ngOnInit(): void {
    this.openAuthModalWithDelay();
  }

  public openAuthModalWithDelay(): void {
    setTimeout( () => {
      this.matDialog.open<LoginAndRegDialogComponent>(LoginAndRegDialogComponent, {width: '630px'});
    }, 2000);
  }

}
